import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const usePrefetch = (path: string) => {
  const router = useRouter();
  const [prefetched, setPrefetched] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !prefetched) {
      setPrefetched(true);
      router.prefetch(path).catch((err) => {
        console.error(err);
      });
    }
  }, [router, path, prefetched]);
};

export default usePrefetch;
